import React from "react"
import {FieldManagementPreviewProps} from "../../../../render/management-preview";

export default function FieldAddress_ManagementPreview(props: FieldManagementPreviewProps) {

    return (
        <div className="flex-row-left-center txt-truncate">
            <div className="i5-location ui5-ico-16 m-r-5"></div>
            <div className="ui5-txt-default txt-truncate">
                Address name
            </div>
        </div>
    )
}
